(function () {
  var root = document.querySelector(".qurtens-legal__body");
  if (!root) return;

  root.querySelectorAll("h1, .rc-policy__header").forEach(function (el) {
    el.remove();
  });

  var firstP = root.querySelector("p");
  if (firstP && /^\s*last updated/i.test(firstP.textContent || "")) {
    firstP.remove();
  }

  var headings = Array.prototype.slice.call(root.querySelectorAll("h2"));
  if (!headings.length) return;

  var alreadyNumbered = headings.some(function (heading) {
    return /^\d+[.)]/.test((heading.textContent || "").trim());
  });
  if (alreadyNumbered) return;

  headings.forEach(function (heading, index) {
    var text = (heading.textContent || "").trim();
    if (!text) return;
    heading.textContent = index + 1 + ". " + text;
  });
})();
